import icon from '@assets/img/icons/company-info.svg';
import { strings as membershipFormStrings } from '@data/membershipForm';
import { createStrings } from '@utils/local';
import { PageMeta } from '@utils/pages';

const strings = createStrings({
  ja: {
    title: membershipFormStrings.companyInfo,
  },
});

export const meta: PageMeta = {
  title: strings.title,
  icon,
  order: 1,
};
